import React, { PureComponent } from 'react';
import { useTranslation, withTranslation, Trans } from 'react-i18next';

import { Link } from 'formlabs-web-components/Link';
import { Select } from 'formlabs-web-components/Form';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import classNames from 'classnames';

import { wrapMultiline } from '../../utils';

import './DataSheets.module.css';

const nameFieldComp = (a, b) => (a.fields.name > b.fields.name ? 1 : -1);

class Materials extends React.Component {
  render() {
    const resins = this.props.materials;
    const resinsSorted = resins.sort(nameFieldComp);

    let renderList = resinsSorted.map((resin, i) => {
      return (
        <option
          key={`data-sheet-resin-` + resin.pk}
          name="resin"
          value={resin.pk}
        >
          {resin.fields.name}
        </option>
      );
    });

    return renderList;
  }
}

class Languages extends React.Component {
  render() {
    const { languages } = this.props;
    const languagesSorted = languages.sort(nameFieldComp);
    let renderList = languagesSorted.map((language, i) => {
      return (
        <option
          key={`data-sheet-language-` + language.pk}
          name="resin"
          value={language.pk}
        >
          {language.fields.name}
        </option>
      );
    });

    return renderList;
  }
}

const Status = ({ selectedL, selectedM, result, languages, materials }) => {
  const [t] = useTranslation();
  const resultM = materials.find(material => material.pk === selectedM);
  const resultL = languages.find(language => language.pk === selectedL);

  if (!resultL || !resultM) {
    return null;
  }

  return (
    <div>
      {t(
        'Displaying {{count}} results for {{material}} Data Sheets in {{language}}',
        {
          count: result,
          material: resultM.fields.name,
          language: resultL.fields.name
        }
      )}
    </div>
  );
};

const Pdfs = ({ pdfs }) =>
  pdfs.map(pdf => {
    return (
      <li key={`pdf-` + pdf.pk}>
        <a styleName="linked-pdf" href={pdf.file}>
          <i className="fl-pdf" styleName="pdf-icon" /> {pdf.display_name}
        </a>
      </li>
    );
  });

const DataSheets = DisplayComponent(
  class App extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        pdfs: this.props.pdfs,
        languages: this.props.languages,
        materials: this.props.materials,
        selectedLanguage: '',
        selectedMaterial: '',
        color: this.props.color,
        open: false
      };
    }

    handleClick = () => {
      this.setState({ open: true });

      var elmList = document.getElementsByClassName('data-sheet-buttons');

      for (var i = 0; i < elmList.length; i++) {
        elmList[i].className = 'data-sheet-buttons full content';
      }

      let e = document.getElementById('pdf-languages');
      let language = parseFloat(e.options[e.selectedIndex].value);

      this.setState({ selectedLanguage: language });

      let m = document.getElementById('pdf-materials');
      let material = parseFloat(m.options[m.selectedIndex].value);

      this.setState({ selectedMaterial: material });
    };

    render() {
      const { t, classes } = this.props;
      let pdfs = this.state.pdfs.filter(pdf => {
        return (
          pdf.resins === this.state.selectedMaterial &&
          pdf.language === this.state.selectedLanguage
        );
      });
      let technical_pdfs = pdfs.filter(pdf => pdf.sheet_type === 'technical');
      let safety_pdfs = pdfs.filter(pdf => pdf.sheet_type === 'safety');
      let updated_technical = null;
      let updated_safety = null;
      let defaultL = this.state.languages.find(
        language => language.fields.is_default === true
      );
      const pdfFilter = (pdf, type) => {
        return (
          pdf.resins === this.state.selectedMaterial &&
          pdf.language === defaultL.pk &&
          pdf.sheet_type === type
        );
      };
      if (!technical_pdfs.length && this.state.selectedLanguage !== 2) {
        try {
          technical_pdfs = this.state.pdfs.filter(pdf => {
            return pdfFilter(pdf, 'technical');
          });

          let selectedL = this.state.languages.find(
            language => language.pk === this.state.selectedLanguage
          );
          if (technical_pdfs.length > 0) {
            updated_technical = (
              <p>
                {t(
                  'There is no technical data sheet in {{selectedLanguage}}. These are the data sheets in {{defaultLanguage}}',
                  {
                    selectedLanguage: selectedL.fields.name,
                    defaultLanguage: defaultL.fields.name
                  }
                )}
              </p>
            );
          } else {
            updated_technical = (
              <p>
                {t(
                  'There is no technical data sheet available for the chosen material.'
                )}
              </p>
            );
          }
        } catch (err) {}
      } else if (!technical_pdfs.length) {
        try {
          updated_technical = (
            <p>
              {t(
                'There is no technical data sheet available for the chosen material.'
              )}
            </p>
          );
        } catch (err) {}
      }

      if (!safety_pdfs.length && this.state.selectedLanguage !== 2) {
        try {
          safety_pdfs = this.state.pdfs.filter(pdf => {
            return pdfFilter(pdf, 'safety');
          });
          let selectedL = this.state.languages.find(
            language => language.pk === this.state.selectedLanguage
          );
          if (safety_pdfs.length > 0) {
            updated_safety = (
              <p>
                {t(
                  'There is no safety data sheet in {{selectedLanguage}}. These are the data sheets in {{defaultLanguage}}',
                  {
                    selectedLanguage: selectedL.fields.name,
                    defaultLanguage: defaultL.fields.name
                  }
                )}
              </p>
            );
          } else {
            updated_safety = (
              <p>
                {t(
                  'There is no safety data sheet available for the chosen material.'
                )}
              </p>
            );
          }
        } catch (err) {}
      } else if (!safety_pdfs.length) {
        try {
          updated_safety = (
            <p>
              {t(
                'There is no safety data sheet available for the chosen material.'
              )}
            </p>
          );
        } catch (err) {}
      }
      const {
        open,
        selectedLanguage,
        selectedMaterial,
        materials,
        languages,
        color
      } = this.state;

      const containerclasses = classNames(color, { open: open });
      return (
        <div
          id="data-sheets"
          className={classNames(containerclasses, classes)}
          styleName={containerclasses}
        >
          <div styleName="data-sheet-options">
            <div styleName="content">
              <h3>{t('Data Sheets')}</h3>
              <p>
                {t(
                  'Download safety and technical data sheets for all Formlabs materials.'
                )}
              </p>
              <ul styleName="data-sheet-details">
                <li>
                  <span>{t('Handling & Safety')}</span>
                  <div>
                    <h4>{t('Handling & Safety')}</h4>
                    <Trans>
                      <p>
                        Resin should be handled with care. Proper handling will
                        ensure safe printing and efficient use. Our resins have
                        been designed to be similar or safer to handle as other
                        household chemicals or adhesives. Formlabs materials do
                        not contain volatile solvents so special ventilation is
                        not required. Skin contact should be avoided.
                      </p>
                      <p>
                        The Safety Data Sheets (SDS) are up to date for every
                        resin product and follow the latest government
                        guidelines. Always consult the SDS as the primary source
                        of information to understand safety and handling of
                        Formlabs materials. For more information about handling
                        resin, learn more{' '}
                        <Link to="https://support.formlabs.com/s/article/Resin-Care?language=en_US">
                          tips for resin maintenance
                        </Link>{' '}
                        in our Help Center.
                      </p>
                    </Trans>
                  </div>
                </li>
                <li>
                  <span>{t('Technical Data')}</span>
                  <div>
                    <h4>{t('Technical Data')}</h4>
                    {wrapMultiline(t('datasheet: technical data text'))}
                  </div>
                </li>
              </ul>
            </div>
            <ul styleName={classNames('content', 'data-sheet-buttons')}>
              <li>
                <p>{t('Material')}</p>
                <span styleName="wrapper">
                  <Select
                    id="pdf-materials"
                    aria-label={t('material selector')}
                  >
                    <option>– {t('Select')} –</option>
                    <Materials materials={this.state.materials} />
                  </Select>
                </span>
              </li>
              <li>
                <p>{t('Language')}</p>
                <span styleName="wrapper">
                  <Select
                    id="pdf-languages"
                    aria-label={t('language selector')}
                  >
                    <option>– {t('Select')} –</option>
                    <Languages languages={this.state.languages} />
                  </Select>
                </span>
              </li>
              <li className="data-search">
                <button
                  onClick={this.handleClick}
                  id="data-sheet-search"
                  styleName="search"
                >
                  {t('Search')}
                </button>
              </li>
            </ul>
            <div id="pdfs" styleName="pdfs">
              <div styleName={classNames('content', 'status')} id="status">
                <Status
                  selectedL={selectedLanguage}
                  selectedM={selectedMaterial}
                  materials={materials}
                  languages={languages}
                  result={safety_pdfs.length + technical_pdfs.length}
                />
              </div>
              <hr />
              <div styleName="content results">
                <div styleName="results-left">
                  <h3>{t('Technical Data Sheets')}</h3>
                  {updated_technical}
                </div>
                <ul>
                  <Pdfs pdfs={technical_pdfs} />
                </ul>
              </div>
              <hr />
              <div styleName="content results">
                <div styleName="results-left">
                  <h3>{t('Safety Data Sheets')}</h3>
                  {updated_safety}
                </div>
                <ul>
                  <Pdfs pdfs={safety_pdfs} />
                </ul>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);

DataSheets.propTypes = {};

export default withTranslation()(DataSheets);
